import script from "./ShiftNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftNotifications.vue?vue&type=script&setup=true&lang=js"

import "./ShiftNotifications.vue?vue&type=style&index=0&id=223f5edb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223f5edb"]])

export default __exports__